export default __webpack_public_path__ + "static/media/junifeup.249a9a27.png";